import { CloseApp, syncPlayer, usePlayerInit, wasDormant } from '@/composables/game/player'
import { initializeAuth, useAuth, useAuthInit } from '@/composables/auth'
import webapp from '@/services/webapp'
import { initializeCipherConfig, initializeConfig } from '@/composables/game/config'
import { syncTap } from '@/composables/game/tap'
import { useRouter } from 'vue-router'
import { RouteName } from '@/routes'
import { initSeason } from '@/composables/season'
import WebApp from '@twa-dev/sdk'
import { env } from '@/env'
import { useBadges } from '@/composables/game/badge'
import { useSessionStorage } from '@vueuse/core'
import { buildDropeeStorageKey } from '@/config/config'

export const hideTonPayment = useSessionStorage<boolean>(buildDropeeStorageKey('hideTonPayment'), false)

export const useInit = () => {
  const router = useRouter()
  useAuthInit()
  usePlayerInit()

  const startParam = webapp.getStartParam()
  const searchParams = new URLSearchParams(window.location.search)
  const pageParam = searchParams.get('page')
  if (startParam === 'ref_exSqgLfxLg0') {
    hideTonPayment.value = true
  }
  if (wasDormant.value) {
    router.push({ name: RouteName.REWARDS })
  } else if (startParam?.startsWith('page_')) {
    const parts = startParam.split('_')
    if (parts[1] === 'friends') {
      router.push({ name: RouteName.FRIENDS, query: { friendshipId: startParam?.substring('page_friends_'.length) } })
    } else if (parts[1] === 'reward') {
      router.push({ name: RouteName.REWARDS })
    } else if (parts[1] === 'settings') {
      router.push({ name: RouteName.SETTINGS })
    }
  } else if (startParam?.startsWith('pagev2_')) {
    const parts = startParam.split('_')
    router.push({ name: parts[1] })
  } else if (pageParam) {
    router.push({ name: pageParam, query: { task: searchParams.get('task') } })
  }
}

export async function initialize() {
  const action = new URLSearchParams(window.location.search).get('action')
  if (action === 'cache.clear') {
    localStorage.clear()
    webapp.close()
    return
  }
  const { profile } = useAuth()
  const { getBadges } = useBadges()

  const playerIdFromApp = WebApp.initDataUnsafe.user?.id ?? 0
  const hasImpersonationToken = window.location.search.includes('impersonationToken')
  if (env.app.isProd && profile.value.id && playerIdFromApp && profile.value.id !== playerIdFromApp && !hasImpersonationToken) {
    await webapp.showAlert('You are already using Dropee with another account. Please return to your original account and reopen the game to continue playing.')
    webapp.close()
    return
  }

  try {
    initSeason()
    await initializeAuth()
    await initializeConfig()
    await initializeCipherConfig()
    await syncTap()
    await syncPlayer(true)
    await getBadges()
  } catch (e) {
    if (e instanceof CloseApp) {
      await webapp.showAlert(e.message)
    } else {
      const errorMessage = (e as { message?: string }).message ?? ''
      await webapp.showAlert(errorMessage && !errorMessage.startsWith('Unexpected token') ? errorMessage : 'Something went wrong. Please try again later.')
    }
    webapp.close()
  }
}
